import { IEscola } from "@deltasge/marauders-map";

import { createActionWithPayload } from "store/helpers";
import { ActionTypes } from "./types";

export const set = createActionWithPayload<IEscola>(ActionTypes.SET);
